import React, {useState, useEffect} from "react";
import {
    useStripe,
    useElements,
    CardNumberElement,
    CardExpiryElement,
    CardCvcElement,
} from '@stripe/react-stripe-js';
import MusicDashboard from '../../layouts/musicDashboard';
import AccountNav from '../../elements/accountElements/accountNav';
import Spinner from 'react-bootstrap/Spinner';
import Swal from 'sweetalert2';

import { showLoading, hideLoading } from 'react-redux-loading-bar';
import {connect} from 'react-redux';
import * as subscriptionAction from '../../store/subscription/actions';
import { API_BASE_URL } from '../../services/config';

const ELEMENT_OPTIONS = {
    style: {
        base: {
            fontSize: '16px',
            lineHeight: '38px',
            color: '#FFFFFF',
            fontFamily: 'Inter, system-ui, sans-serif',
            '::placeholder': { color: '#9ca3af' },
        },
        invalid: {
            color: '#ef4444',
        },
    },
};

const UpdateStripeCard = ({customerProfile, displayLoading, hideLoading, updatePaymentMethod}) => {
    const stripe = useStripe();
    const elements = useElements();

    const [clientSecret, setClientSecret] = useState(null);
    const [processing, setProcessing] = useState(false);
    const [error, setError] = useState('');

    const isEligible = customerProfile
        && customerProfile.current_payment_method === 'Stripe'
        && customerProfile.payment_profile_status === 'paid'
        && (customerProfile.profile_status === 'Active' || customerProfile.profile_status === 'ACTIVE');

    useEffect(() => {
        if (!isEligible) return;
        fetch(API_BASE_URL+'stripe/create-setup-intent.json')
            .then(res => res.json())
            .then(data => {
                setClientSecret(data.data.client_secret);
            });
    }, [isEligible]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (!stripe || !elements || !clientSecret) return;

        setProcessing(true);
        displayLoading();

        const result = await stripe.confirmCardSetup(clientSecret, {
            payment_method: {
                card: elements.getElement(CardNumberElement),
                billing_details: {
                    name: customerProfile.dj_name,
                    email: customerProfile.email,
                },
            },
        });

        if (result.error) {
            setError(result.error.message);
            setProcessing(false);
            hideLoading();
            return;
        }

        const paymentMethodId = result.setupIntent.payment_method;

        await updatePaymentMethod({payment_method: paymentMethodId}).then(res => {
            if (res && res.payload && res.payload.data && res.payload.data.success) {
                elements.getElement(CardNumberElement).clear();
                elements.getElement(CardExpiryElement).clear();
                elements.getElement(CardCvcElement).clear();
                Swal.fire({
                    icon: 'success',
                    title: 'Card updated successfully!',
                    text: res.payload.data.message,
                });
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Update Failed!',
                    text: (res && res.payload && res.payload.data && res.payload.data.message) || 'Something went wrong. Please try again.',
                });
            }
        });

        setProcessing(false);
        hideLoading();
    };

    return (
        <MusicDashboard accountPages={true} middleSectionCssClass={'account-info-sec'}>
            <div className="content-sec">
                <div className="account-block">
                    <div className="top-heading">
                        <h2>Account Settings</h2>
                    </div>
                    <AccountNav />
                    <div className="edit-profile"  style={{ maxWidth: 320, margin: '0 auto' }}>
                        <div className="title-heading" style={{marginBottom: '10px'}}><h2>Update Card</h2></div>
                    </div>
                    <div className="account-inner-block" style={{ maxWidth: 320, margin: '0 auto' }}>
                        {
                            !isEligible ?
                                <div className="alert alert-danger">This page is only available to active, paid Stripe subscribers.</div>
                            :
                                <form onSubmit={handleSubmit} >
                                    <div className="form-group card-payment">
                                        <label className="form-label">Card Number</label>
                                        <div className="input-box form-control">
                                            <CardNumberElement options={ELEMENT_OPTIONS} />
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="form-group card-payment">
                                            <label className="form-label">Expiry</label>
                                            <div className="input-box form-control">
                                                <CardExpiryElement options={ELEMENT_OPTIONS} />
                                            </div>
                                        </div>

                                        <div className="form-group card-payment">
                                            <label className="form-label">CVC</label>
                                            <div className="input-box form-control">
                                                <CardCvcElement options={ELEMENT_OPTIONS} />
                                            </div>
                                        </div>
                                    </div>

                                    {error && <p className="error">{error}</p>}

                                    {
                                        processing ?
                                            <button disabled="disabled" className="primary-btn card-payment"><Spinner animation="border" size="sm" variant="dark" /></button>
                                            : <button className="primary-btn card-payment" disabled={!stripe}>Update Card</button>
                                    }
                                </form>
                        }
                    </div>
                </div>
            </div>
        </MusicDashboard>
    );
};

function mapStateToProps(state) {
    return {
        customerProfile: state.customer.customerProfile,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        displayLoading: (sectionBar) => dispatch(showLoading(sectionBar)),
        hideLoading: (sectionBar) => dispatch(hideLoading(sectionBar)),
        updatePaymentMethod: (post) => dispatch(subscriptionAction.updatePaymentMethod(post)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(UpdateStripeCard);
